<div class="container" fxLayout="column" fxLayout.lt-md="row" ngClass.lt-md="rowSidebar">
  <div fxLayout="row" fxLayout.lt-md="column">
    <img class="headshot" src="assets/me.png">
  </div>
  <div fxLayout="column" ngClass.lt-md="rowBio">
    <p>My name is Nils Thingvall. I'm a staff engineer at Dolby Laboratories. I do work on video-centric applications on a variety of platforms (web, Node, Roku, Chromecast, and Android).</p>
    <p>Outside of work, I focus on cooking, board games, and watching the good cartoons. Oh, and my kids. They're around here somewhere...</p>
  </div>
</div>
